// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeContestTiebreakSetBody = {
  poolId: string;
  contestId: string;
  winnerEntryIds: string[];
};

export type typeContestTiebreakSetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    contestId: string;
    commissionerNamedWinnerIds: string[];
    commissionerNamedAtMs: number;
    editableUntilMs: number;
  };
};

export type typeContestTiebreakSetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestTiebreakSetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestTiebreakSetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaContestTiebreakSetBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    contestId: { type: "string", maxLength: 3000, minLength: 1 },
    winnerEntryIds: {
      type: "array",
      items: { type: "string", maxLength: 3000, minLength: 1 },
    },
  },
  required: ["poolId", "contestId", "winnerEntryIds"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createContestTiebreakSet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaContestTiebreakSetBody);
  }

  return async function postContestTiebreakSet(
    payload: typeContestTiebreakSetBody,
  ): Promise<
    typeContestTiebreakSetOutput200 | typeContestTiebreakSetOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postContestTiebreakSet" failed before calling the network. #a0e29cddcb93`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#a0e29cddcb93" },
        },
        data: null,
      } as typeContestTiebreakSetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/contest/tiebreak-set`,
      httpMethod: "POST",
      options,
    })) as typeContestTiebreakSetOutput200 | typeContestTiebreakSetOutput400;
  };
}
